// src/components/reports/reportsIcons.tsx — Reports measure glyphs + the
// home-pin glyph. Ported verbatim from the prototype reports-charts.jsx RIcon
// set: bespoke brass-tuned glyphs that aren't in the shared Icon set, kept
// local so the applet matches the prototype exactly.

import type { CSSProperties } from "react";

interface RGlyphProps {
  s?: number;
  c?: string;
  sw?: number;
  fill?: boolean;
  style?: CSSProperties;
}
interface BaseProps extends RGlyphProps {
  d: string | string[];
}

const RGlyph = ({ d, s = 22, c = "currentColor", sw = 1.7, fill = false, style }: BaseProps) => (
  <svg
    width={s}
    height={s}
    viewBox="0 0 24 24"
    fill={fill ? c : "none"}
    stroke={fill ? "none" : c}
    strokeWidth={sw}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "block", flexShrink: 0, ...style }}
  >
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);

export const RIcon = {
  Coins: (p: RGlyphProps) => <RGlyph {...p} d={["M8 8a5 3 0 1 0 0-6 5 3 0 0 0 0 6z", "M3 5v6c0 1.7 2.2 3 5 3s5-1.3 5-3V5", "M13 13.5c1.2 1 3.3 1.5 5 1.5 2.8 0 5-1.3 5-3v-6", "M11 18.5c.6 1 2.7 1.5 5 1.5 2.8 0 5-1.3 5-3"]} />,
  GiftAid: (p: RGlyphProps) => <RGlyph {...p} d={["M12 21s-7-4.5-7-10a4 4 0 0 1 7-3 4 4 0 0 1 7 3c0 5.5-7 10-7 10z", "M9.5 11.5 11 13l3.5-3.5"]} />,
  Footfall: (p: RGlyphProps) => <RGlyph {...p} d={["M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M2 20c1-3.5 3.5-5.5 7-5.5s6 2 7 5.5", "M17 11a3 3 0 1 0 0-6", "M16 20c.5-2.5 2-4 4-4.5"]} />,
  Bars: (p: RGlyphProps) => <RGlyph {...p} d={["M4 20V10", "M10 20V4", "M16 20v-7", "M21 20H3"]} />,
  Pullman: (p: RGlyphProps) => <RGlyph {...p} d={["M5 8h11a3 3 0 0 1 3 3 3 3 0 0 1-3 3H5z", "M5 14v3", "M19 11h2a1 1 0 0 1 0 4h-2", "M4 21h13"]} />,
  Gauge: (p: RGlyphProps) => <RGlyph {...p} d={["M4 18a8 8 0 1 1 16 0", "M12 18l4-5"]} />,
  Event: (p: RGlyphProps) => <RGlyph {...p} d={["M4 6h16v15H4z", "M4 10h16", "M9 3v4", "M15 3v4", "M9 15l2 2 4-4"]} />,
  HomePin: (p: RGlyphProps) => <RGlyph {...p} d={["M4 11.5 12 5l8 6.5", "M6 10.5V19h12v-8.5"]} />,
  Refresh: (p: RGlyphProps) => <RGlyph {...p} d={["M21 12a9 9 0 1 1-2.6-6.4", "M21 4v5h-5"]} />,
};
